export const createClassString = (classOptions: { [key: string]: boolean }) => {
  let classes = '';
  Object.keys(classOptions).map(key => {
    classOptions[key] && (classes += ` ${key}`);
  });
  return classes;
};
